import { render, staticRenderFns } from "./FavoriteButtonComponent.vue?vue&type=template&id=59b289b6"
import script from "./FavoriteButtonComponent.vue?vue&type=script&lang=js"
export * from "./FavoriteButtonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports